import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiFormHelperText from "@mui/material/FormHelperText";

// Source
import * as HelperSrc from "../HelperSrc";
import * as ModelUser from "../model/User";
import ControllerLocalization from "../controller/Localization";
import ControllerMyProfile from "../controller/MyProfile";
import ViewLoader from "./Loader";

let isRendered = false;

const viewPageMyProfile: React.FC<ModelUser.Iprops> = (props) => {
    // Variable
    const controllerMyProfile = new ControllerMyProfile(props, isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerMyProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerMyProfile.getValidationForm) {
        return (
            <div className="view_my_profile form" data-at_id="view_my_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerMyProfile.getUser) {
                        html.push(
                            <div>
                                <div className="field_container">
                                    <MuiTextField
                                        variant="outlined"
                                        className="field_value disabled"
                                        name="id"
                                        label={controllerLocalization.getStorageMain.id}
                                        defaultValue={controllerMyProfile.getUser.id}
                                        disabled
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <MuiTextField
                                        variant="outlined"
                                        className="field_value disabled date"
                                        name="last_activity"
                                        label={controllerLocalization.getStorageMain.profile_last_activity}
                                        value={
                                            controllerMyProfile.getUser.last_activity
                                                ? HelperSrc.localeFormat(new Date(controllerMyProfile.getUser.last_activity))
                                                : ""
                                        }
                                        disabled
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <MuiTextField
                                        variant="outlined"
                                        className="field_value disabled"
                                        name="auth_type"
                                        label={controllerLocalization.getStorageMain.profile_auth_type}
                                        defaultValue={controllerMyProfile.getUser.auth_type}
                                        disabled
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <MuiTextField
                                        variant="outlined"
                                        className="field_value"
                                        data-at_id="input_username"
                                        name="username"
                                        label={controllerLocalization.getStorageMain.username}
                                        defaultValue={controllerMyProfile.getUser.username}
                                        required={controllerMyProfile.getValidationForm.username.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.username.regex_pattern,
                                                    controllerMyProfile.getValidationForm.username.error_msg
                                                );
                                            }
                                        }}
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <MuiTextField
                                        variant="outlined"
                                        className="field_value"
                                        data-at_id="input_first_name"
                                        name="first_name"
                                        label={controllerLocalization.getStorageMain.first_name}
                                        defaultValue={controllerMyProfile.getUser.first_name}
                                        required={controllerMyProfile.getValidationForm.first_name.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.first_name.regex_pattern,
                                                    controllerMyProfile.getValidationForm.first_name.error_msg
                                                );
                                            }
                                        }}
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <MuiTextField
                                        variant="outlined"
                                        className="field_value"
                                        data-at_id="input_last_name"
                                        name="last_name"
                                        label={controllerLocalization.getStorageMain.last_name}
                                        defaultValue={controllerMyProfile.getUser.last_name}
                                        required={controllerMyProfile.getValidationForm.last_name.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.last_name.regex_pattern,
                                                    controllerMyProfile.getValidationForm.last_name.error_msg
                                                );
                                            }
                                        }}
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <MuiTextField
                                        variant="outlined"
                                        className="field_value"
                                        data-at_id="input_email"
                                        name="email"
                                        label={controllerLocalization.getStorageMain.email}
                                        defaultValue={controllerMyProfile.getUser.email}
                                        required={controllerMyProfile.getValidationForm.email.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.email.regex_pattern,
                                                    controllerMyProfile.getValidationForm.email.error_msg
                                                );
                                            }
                                        }}
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <span className="checkbox_label">{controllerLocalization.getStorageMain.is_active}:</span>
                                    <MuiCheckbox
                                        className="field_value checkbox_style"
                                        data-at_id="input_is_active"
                                        name="is_active"
                                        defaultChecked={controllerMyProfile.getUser.is_active}
                                        required={controllerMyProfile.getValidationForm.is_active.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.is_active.regex_pattern,
                                                    controllerMyProfile.getValidationForm.is_active.error_msg
                                                );
                                            }
                                        }}
                                        disabled
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <span className="checkbox_label">{controllerLocalization.getStorageMain.profile_is_checkbox_superuser}:</span>
                                    <MuiCheckbox
                                        className="field_value checkbox_style"
                                        data-at_id="input_is_checkbox_superuser"
                                        name="is_checkbox_superuser"
                                        defaultChecked={controllerMyProfile.getUser.is_checkbox_superuser}
                                        required={controllerMyProfile.getValidationForm.is_checkbox_superuser.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.is_checkbox_superuser.regex_pattern,
                                                    controllerMyProfile.getValidationForm.is_checkbox_superuser.error_msg
                                                );
                                            }
                                        }}
                                        disabled
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <span className="checkbox_label">{controllerLocalization.getStorageMain.profile_is_checkbox_manager}:</span>
                                    <MuiCheckbox
                                        className="field_value checkbox_style"
                                        data-at_id="input_is_checkbox_manager"
                                        name="is_checkbox_manager"
                                        defaultChecked={controllerMyProfile.getUser.is_checkbox_manager}
                                        required={controllerMyProfile.getValidationForm.is_checkbox_manager.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.is_checkbox_manager.regex_pattern,
                                                    controllerMyProfile.getValidationForm.is_checkbox_manager.error_msg
                                                );
                                            }
                                        }}
                                        disabled
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <span className="checkbox_label">{controllerLocalization.getStorageMain.profile_is_checkbox_staff}:</span>
                                    <MuiCheckbox
                                        className="field_value checkbox_style"
                                        data-at_id="input_is_checkbox_staff"
                                        name="is_checkbox_staff"
                                        defaultChecked={controllerMyProfile.getUser.is_checkbox_staff}
                                        required={controllerMyProfile.getValidationForm.is_checkbox_staff.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.is_checkbox_staff.regex_pattern,
                                                    controllerMyProfile.getValidationForm.is_checkbox_staff.error_msg
                                                );
                                            }
                                        }}
                                        disabled
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <span className="checkbox_label">{controllerLocalization.getStorageMain.profile_is_checkbox_support}:</span>
                                    <MuiCheckbox
                                        className="field_value checkbox_style"
                                        data-at_id="input_is_checkbox_support"
                                        name="is_checkbox_support"
                                        defaultChecked={controllerMyProfile.getUser.is_checkbox_support}
                                        required={controllerMyProfile.getValidationForm.is_checkbox_support.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.is_checkbox_support.regex_pattern,
                                                    controllerMyProfile.getValidationForm.is_checkbox_support.error_msg
                                                );
                                            }
                                        }}
                                        disabled
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
                {(() => {
                    const html: JSX.Element[] = [];

                    if (HelperSrc.ENV_NAME === "local" || HelperSrc.ENV_NAME === "dev_jp" || HelperSrc.ENV_NAME === "dev_us") {
                        html.push(
                            <div>
                                <div className="field_container">
                                    <MuiTextField
                                        type="password"
                                        variant="outlined"
                                        className="field_value"
                                        data-at_id="input_password"
                                        name="password"
                                        label={controllerLocalization.getStorageMain.psw}
                                        required={controllerMyProfile.getValidationForm.psw.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.psw.regex_pattern,
                                                    controllerMyProfile.getValidationForm.psw.error_msg
                                                );
                                            }
                                        }}
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div className="field_container">
                                    <MuiTextField
                                        type="password"
                                        variant="outlined"
                                        className="field_value"
                                        data-at_id="input_confirm_password"
                                        name="confirm_password"
                                        label={controllerLocalization.getStorageMain.profile_confirm_psw}
                                        required={controllerMyProfile.getValidationForm.psw.required}
                                        onChange={(event) => {
                                            if (controllerMyProfile.getValidationForm) {
                                                HelperSrc.checkRegex(
                                                    event.target,
                                                    event.target.value,
                                                    controllerMyProfile.getValidationForm.psw.regex_pattern,
                                                    controllerMyProfile.getValidationForm.psw.error_msg
                                                );
                                            }
                                        }}
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
                <div className="bottom">
                    <div className="button_container">
                        <MuiButton
                            className="button_primary"
                            data-at_id="button_change"
                            disabled={controllerMyProfile.getApiLoadingList.profileChange}
                            onClick={(event) => {
                                controllerMyProfile.clickChange(event);
                            }}
                        >
                            {(() => {
                                const html: JSX.Element[] = [];

                                if (controllerMyProfile.getApiLoadingList.profileChange) {
                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                } else {
                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                }

                                return html;
                            })()}
                        </MuiButton>
                    </div>
                </div>
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageMyProfile;
